/** @jsx jsx */
import React from 'react'
import PropTypes from 'prop-types'
import {jsx, Global} from '@instructure/emotion'
import {withStyleOverrides} from '@instructure/quiz-common/util/withStyleOverrides'
import t from 'format-message'

import generateStyle from './styles'
import generateComponentTheme from './theme'

class PageHeaderUnstyled extends React.Component {
  static displayName = 'PageHeader'
  static componentId = `Quizzes${this.displayName}`

  static propTypes = {
    children: PropTypes.node.isRequired,
    isNewTopNavBar: PropTypes.bool,
    makeStyles: PropTypes.func,
    styles: PropTypes.object,
  }

  static defaultProps = {
    isNewTopNavBar: false,
  }

  componentDidMount() {
    this.props.makeStyles()
  }

  componentDidUpdate() {
    this.props.makeStyles()
  }

  render() {
    return (
      <header className="header" css={this.props.styles.header} aria-label={t('Quiz header')}>
        <Global styles={this.props.styles.globalStyles} />
        <div css={this.props.styles.headerContent}>{this.props.children}</div>
      </header>
    )
  }
}

const PageHeader = withStyleOverrides(generateStyle, generateComponentTheme)(PageHeaderUnstyled)
export default PageHeader
